import type { AgentEditChromeAction, AgentEditChromeState } from './types';

export const initialAgentEditChromeState: AgentEditChromeState = {
	ranges: [],
	revision: 0,
};

export const reduceAgentEditChromeState = (
	state: AgentEditChromeState,
	action: AgentEditChromeAction,
): AgentEditChromeState => {
	switch (action.type) {
		case 'SHOW':
			return {
				...action.data,
				revision: state.revision + 1,
			};
		case 'REMOVE':
			return action.revision === state.revision
				? {
						ranges: [],
						revision: state.revision,
					}
				: state;
	}
};
